import type { SVGProps } from 'react'
const SvgSyArrowLeftCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M12 2C6.487 2 2 6.486 2 12c0 5.513 4.487 10 10 10s10-4.487 10-10c0-5.514-4.487-10-10-10m0 1.5c4.703 0 8.5 3.796 8.5 8.5a8.49 8.49 0 0 1-8.5 8.5A8.49 8.49 0 0 1 3.5 12c0-4.704 3.797-8.5 8.5-8.5"
				clipRule="evenodd"
				opacity={0.4}
			/>
			<path d="m12.914 7.998-3.486 3.47a.75.75 0 0 0 0 1.063l3.486 3.471a.75.75 0 0 0 1.06-.002.75.75 0 0 0-.003-1.06L11.02 12l2.95-2.94A.75.75 0 0 0 13.976 8a.75.75 0 0 0-1.06-.002" />
		</g>
	</svg>
)
export default SvgSyArrowLeftCircle
